module.exports = __webpack_public_path__ + "img/exposicion_humana_glifosato_web.cf11a7a2.png";